export default __webpack_public_path__ + "static/media/remark_icon.55976b79.svg";